import NetworkHandler from 'utils/network';
import config from 'config';

function getTicketTypes() {
    return NetworkHandler.get(`${config.getUrl('get_ticket_types')}?version=v2`);
}


export default {
    getTicketTypes,
};
